import React from 'react';
import { ExportToCsv } from 'export-to-csv';
import { translate } from '../../Services/translation';
import { Plus } from 'phosphor-react';

const QuickOrderFooter = (props) => {
  const {
    getCompleteRows,
    addMultipleToCart,
    clearRows,
    canAddToCart,
    addRow,
    addNotification,
    defaultNotification,
  } = props;

  const downloadCSV = () => {
    var rows = getCompleteRows();
    if (rows.length == 0) {
      addNotification({
        type: 'warning',
        text: translate('quickorder.export.no-rows'),
      });
      return;
    }

    return new Promise((resolve, reject) => {
      const csvExporter = new ExportToCsv({
        fieldSeparator: ';',
        useKeysAsHeaders: true,
        filename:
          'IHG_' +
          translate('quickorder') +
          '_' +
          new Date().toISOString().split('T')[0],
      });

      var csvData = [];

      for (var row of rows) {
        // Only valid rows are exported
        if (!row.articleNumber || !row.name || row.quantity <= 0) continue;

        csvData.push({
          articleNumber: row.articleNumber,
          quantity: row.quantity,
        });
      }
      csvExporter.generateCsv(csvData);

      addNotification({
        type: 'success',
        text: translate('quickorder.export.success'),
      });

      resolve();
    });
  };

  const addToCartClick = () => {
    addMultipleToCart(getCompleteRows());
    clearRows();
    addNotification({ ...defaultNotification });
  };

  return (
    <>
      <div>
        <div className="quick-order-footer__add-row">
          <button
            className="btn btn--secondary btn--small d-flex align-center text-medium"
            onClick={() => addRow()}
          >
            <Plus size={20} /> {translate('quickorder.add-row')}
          </button>
        </div>
      </div>

      <div className="[ quick-order-footer__atc ] [ d-flex align-center justify-end ]">
        <button
          className="btn btn--secondary btn--small"
          onClick={() => downloadCSV()}
        >
          {translate('quickorder.export')}
        </button>
        <button
          className="btn buy-button"
          disabled={!canAddToCart}
          onClick={addToCartClick}
        >
          {translate('quickorder.add-to-cart')}
        </button>
      </div>
    </>
  );
};

export default QuickOrderFooter;
